<template>
    <div class="text-center">
        <div v-if="!fail" >
            <h4 class="text-6 mb-4">
                <span v-if="loading">Verifying Your Payment</span>
                <span v-else>
                    Complete Your <img src="/img/ecocash-logo.webp" class="mx-1" style="width: 92px" alt=""> Payment Now
                </span>
            </h4>

            <p class="my-5">
                Please complete payment on your phone. <br>
                <strong>Your purchase will be completed once payment has been processed.</strong>
            </p>

            <p class="small">If you have already completed the payment on your phone, click "Verify Payment" below.</p>

            <div class="form-group">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading disabled' : '']">
                    {{ loading ? 'Verifying' : 'Verify' }} Payment
                </button>
            </div>

            <small class="text-muted">Automatically checking payment in {{ countDown }} seconds.</small>
        </div>
        <div v-else>
            <i class="fa fa-exclamation-triangle fa-2x text-danger"></i>

            <h4 class="text-6 mb-4 mt-3">
                Your <img src="/img/ecocash-logo.webp" class="mx-1" style="width: 92px" alt=""> Payment Failed
            </h4>

            <p class="text-danger mb-5">
                Your payment failed to go through. <br>
                Click "Retry Transaction" below to try again.
            </p>

            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <button @click="back" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">
                            Retry Transaction
                        </button>
                    </div>
                    <div class="col-md-6">
                        <router-link to="/" class="btn btn-outline-primary btn-block shadow-none">Close</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {statusMixin} from "./status-mixin";

export default {
    name: "ecocash.vue",
    mixins: [statusMixin],
    data() {
        return {
            loading: false,
            done: false,
            countDown: 30,
            countDownId: null,
            ref: this.$route.query.id
        };
    },
    methods: {
        submit() {
            if (this.loading || this.done) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/ecocash/check`, {
                ref: this.ref
            }).then((response) => {
                if (response.data.success) {
                    if (response.data.body.pending) {
                        this.countDown = 30;
                        this.startCountDown();
                        return;
                    }

                    this.done = true;

                    let id = this.ref;

                    if (response.data.body.sub) {
                        id = response.data.body.sub;
                    }

                    if (response.data.body.type === "App\\Zesa") {
                        this.$router.push(`/zesa/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\Airtime") {
                        this.$router.push(`/airtime/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\Bundle") {
                        this.$router.push(`/bundles/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\Telone") {
                        this.$router.push(`/telone/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\Zinara") {
                        this.$router.push(`/zinara/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\DeliveryPayment") {
                        this.$router.push(`/zinara/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\GiftPurchase") {
                        this.$router.push(`/gift-cards/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\TicketPurchase") {
                        this.$router.push(`/tickets/complete?id=${id}`);
                    }

                    if (response.data.body.type === "App\\BillerPayment") {
                        this.$router.push(`/billers/complete?id=${id}`);
                    }

                    this.dispatchPaymentStatus(true)

                } else {
                    this.fail = true;
                    this.dispatchPaymentStatus(false)
                }

            }).finally(() => {
                this.loading = false;
            });
        },
        back() {
            this.$router.back();
        },
        startCountDown() {
            if (this.countDownId) clearTimeout(this.countDownId);

            if (this.countDown > 0) {
                this.countDownId = setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);
            } else {
                if (!this.loading) this.submit();
            }
        },
    },

    mounted() {
        this.startCountDown();
    }
}
</script>

<style scoped>

</style>
